import { Link } from "react-router-dom";

export function Field({ label, id, error, required, children, hint, className = "" }) {
  return (
    <div className={className}>
      <label htmlFor={id} className="mb-2 block text-[0.78rem] font-semibold uppercase tracking-[0.12em] text-charcoal/80">
        {label}{required && <span aria-hidden="true" className="text-forest"> *</span>}
      </label>
      {children}
      {hint && <p className="mt-1 text-xs text-charcoal/70">{hint}</p>}
      {error && <p id={`${id}-error`} role="alert" className="mt-1.5 text-xs font-medium text-[#8E2F25]">{error}</p>}
    </div>
  );
}

export function Input({ id, label, error, required, hint, className, ...rest }) {
  return (
    <Field label={label} id={id} error={error} required={required} hint={hint} className={className}>
      <input id={id} name={id} className="field" aria-invalid={!!error} aria-describedby={error ? `${id}-error` : undefined} required={required} data-testid={`input-${id}`} {...rest} />
    </Field>
  );
}

export function Select({ id, label, options, error, required, placeholder = "Please select", className, ...rest }) {
  return (
    <Field label={label} id={id} error={error} required={required} className={className}>
      <select id={id} name={id} className="field" aria-invalid={!!error} required={required} data-testid={`select-${id}`} {...rest}>
        <option value="">{placeholder}</option>
        {options.map((o) => (typeof o === "string" ? <option key={o} value={o}>{o}</option> : <option key={o.value} value={o.value}>{o.label}</option>))}
      </select>
    </Field>
  );
}

export function TextArea({ id, label, error, className, ...rest }) {
  return (
    <Field label={label} id={id} error={error} className={className}>
      <textarea id={id} name={id} rows={4} className="field resize-y" data-testid={`input-${id}`} {...rest} />
    </Field>
  );
}

export function Consent({ id = "consent", checked, onChange, error, children }) {
  return (
    <div>
      <label htmlFor={id} className="flex cursor-pointer items-start gap-3 text-sm leading-relaxed text-charcoal/80">
        <input id={id} type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} data-testid={`checkbox-${id}`}
          className="mt-1 h-4 w-4 shrink-0 accent-[#16352C]" aria-invalid={!!error} />
        <span>{children || <>I agree to Cirencester 4x4 using my details to respond to this enquiry, as described in the <Link to="/legal/privacy" className="underline">Privacy Policy</Link>.</>}</span>
      </label>
      {error && <p role="alert" className="mt-1.5 text-xs font-medium text-[#8E2F25]">{error}</p>}
    </div>
  );
}

export const Honeypot = ({ value, onChange }) => (
  <div aria-hidden="true" className="absolute -left-[9999px] h-0 w-0 overflow-hidden">
    <label>Website<input tabIndex={-1} autoComplete="off" value={value} onChange={(e) => onChange(e.target.value)} /></label>
  </div>
);

export function validateContact(f) {
  const e = {};
  if (!f.name?.trim()) e.name = "Please enter your name";
  if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(f.email || "")) e.email = "Please enter a valid email address";
  if (f.phone !== undefined && f.phone.replace(/\D/g, "").length < 10) e.phone = "Please enter a valid telephone number";
  if (!f.consent) e.consent = "Please confirm you agree to our privacy policy";
  return e;
}

export const CONTACT_METHODS = ["Telephone", "Email", "WhatsApp"];
